module.exports = {
	init: (options) => {
		window.SpreedlyExpress.init(window.iq.spreedlyKey, options);
		window.SpreedlyExpress.onPaymentMethod(function (paymentToken, paymentMethod) {
			if (options.onSubmitting) {
				options.onSubmitting();
			}
			window.jQuery('#paymentToken').val(paymentToken).closest('form').submit();
		});
		window.SpreedlyExpress.onViewClose(() => {
			//this callback is called even during successful checkout.
			//we don't want to re-enable the button in that case.
			if (window.jQuery('#paymentToken').val() === '') {
				window
					.jQuery('#paymentToken')
					.closest('form')
					.find('button[type=submit]')
					.prop('disabled', false)
					.removeClass('disabled');
			}
		});
	},
	update: ({ amountDisplay, fullName, email, street1, street2, city, state, postalCode, nation }) => {
		window.SpreedlyExpress.setDisplayOptions({
			amount: amountDisplay,
			full_name: fullName
		});
		window.SpreedlyExpress.setPaymentMethodParams({
			email,
			address1: street1,
			address2: street2,
			city,
			state,
			zip: postalCode,
			country: nation
		});
	},
	tokenize: () => {
		window.SpreedlyExpress.openView();
		//we sometimes saw spreedly express sidebar contents duplicating, and this fixed it for them
		// window.jQuery('.spreedly-sidebar-divider:gt(0),.spreedly-item:gt(0)').remove();
	}
};
